import styled from 'styled-components';

/**
 * 기존 SettlementListWrap/Toolbar 시각 컨벤션과 맞춘 래퍼/섹션 스타일.
 */

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px;

  /* 테이블 헤더 텍스트 가운데 정렬 (기존 정산 테이블과 동일 톤). */
  .eligible-items-table .ant-table-thead > tr > th {
    text-align: center;
    font-weight: 600;
  }
`;

/**
 * SearchBox와 동일한 카드형 외곽. 카드 제목 + BaseForm 행들을 담는다.
 */
export const StyledActionCard = styled.div`
  padding: 15px 30px;
  background-color: #fff;
  border: 1px solid #e7eaec;

  & > .section-title {
    font-weight: bold;
    font-size: 15px;
    margin: 0 0 15px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e7eaec;
  }

  & > .amondz-form:not(:last-child) {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e7eaec;
  }

  .amondz-form {
    display: flex;
    align-items: center;

    .content {
      padding-left: 50px;
    }
  }
`;

/**
 * SettlementListToolbar와 동일한 상단 액션 바 (선택 건수 + 버튼 그룹).
 */
export const StyledToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledCountText = styled.p`
  font-weight: bold;
  font-size: 14px;
  margin: 0;
  span {
    font-size: 18px;
    color: #6200ea;
  }
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

/**
 * "이력 있는 항목만" 필터의 Switch 전용 래퍼.
 *
 * 프로젝트 전역 `custom_antd.scss`에 antd v3 시절 잔존 룰
 * `.ant-switch-inner { margin-left: 24px; margin-right: 6px }` 이 박혀 있어
 * antd v5 Switch의 ON/OFF 라벨과 핸들(● ) 사이 간격이 과하게 벌어진다.
 * v5에서는 inner 간격을 padding 기반으로 스위치 스스로 계산하므로
 * 이 스코프에서만 레거시 margin을 0으로 되돌려 기본 간격을 복구한다.
 */
export const StyledHistoryOnlySwitch = styled.span`
  display: inline-flex;
  align-items: center;

  .ant-switch .ant-switch-inner {
    margin-left: 0;
    margin-right: 0;
  }
`;
